import { Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewChecked } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { AllDropdownKeys } from '../../../jurisdiction/jurisdiction.constants';
import { LookupOptionsData } from '../../../jurisdiction/jurisdiction.domain';
import { CommonService } from '../../../services/common.service';
import { AddressAndPersonalData } from '../../../+grid-application-shared/entities/personal-data/addressAndPersonalData';

@Component({
  selector: 'app-person-data-fields',
  templateUrl: './person-data-fields.component.html',
  styleUrls: ['./person-data-fields.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class PersonDataFieldsComponent implements OnInit, AfterViewChecked {
  @Input() personData: AddressAndPersonalData;
  @Input() formName: string;
  @Input() hasEmail: boolean;
  @Input() hasCompany: boolean;
  @Input() isDetailsView: boolean;
  @Input() appNotFinished: boolean;
  @Input() isDisabled: boolean;

  @Output() formChangedEvent = new EventEmitter<any>();

  @ViewChild('addressData', { read: NgForm }) addressData: any;

  titleKey: string;
  allTitles: LookupOptionsData[];

  constructor(private commonService: CommonService) {}

  ngOnInit(): void {
    this.titleKey = AllDropdownKeys.Title;
    this.allTitles = this.commonService.getDropdownData(this.titleKey);
    if (this.personData) {
      this.personData.country = 'Deutschland';
    }
  }

  ngAfterViewChecked(): void {
    this.formChanged();
  }

  public formChanged(): void {
    this.formChangedEvent.emit({
      name: this.formName,
      state: this.addressData.valid || this.addressData.form.status === 'DISABLED',
      dirty: this.addressData.dirty,
    });
  }
}
